/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mode de calcul d'une tarification.
 * @export
 */
export const ModeCalculTarification = {
    /**
    * Montant fixe TTC
    */
    MontantFixe: 1,
    /**
    * Taux appliqué à une assiette
    */
    Taux: 2,
    /**
    * Expression de calcul
    */
    Expression: 3,
    /**
    * Montant fixe HT
    */
    MontantFixeHT: 4
} as const;
export type ModeCalculTarification = typeof ModeCalculTarification[keyof typeof ModeCalculTarification];


export function instanceOfModeCalculTarification(value: any): boolean {
    for (const key in ModeCalculTarification) {
        if (Object.prototype.hasOwnProperty.call(ModeCalculTarification, key)) {
            if (ModeCalculTarification[key as keyof typeof ModeCalculTarification] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ModeCalculTarificationFromJSON(json: any): ModeCalculTarification {
    return ModeCalculTarificationFromJSONTyped(json, false);
}

export function ModeCalculTarificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModeCalculTarification {
    return json as ModeCalculTarification;
}

export function ModeCalculTarificationToJSON(value?: ModeCalculTarification | null): any {
    return value as any;
}

export function ModeCalculTarificationToJSONTyped(value: any, ignoreDiscriminator: boolean): ModeCalculTarification {
    return value as ModeCalculTarification;
}

